var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrap},[_c('a-table',{attrs:{"columns":_vm.columns,"rowKey":function (row) { return row.name; },"data-source":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }